/**
 * This module contains the UI
 * to build the waitFor instruction category
 */

// TODO:
// - reduce unneeded notifications
// - unbind events of removed UI elements
// - unify styles
(function() {
  const $ = require('jQuery');
  const instruction_widgets = require('../instruction_widgets');
  const io_widgets = require('../instruction_widgets/io_widgets');
  const icons = require('../../icons');
  const widgets = require('../widgets');
  const utils = require('./utils');
  const helpers = require('../../helpers');
  const ml = require('../../machinelogic');

  const { autocompleteComponent } = require('../vse_ui/vse_components/base_components');

  function create(pParameters) {
    const lLibrary = pParameters.library;
    const lApp = pParameters.application;
    const lSequence = pParameters.sequence;
    const lInstruction = pParameters.instruction;
    let lInstructionListener = {};
    const _lDiv = $('<div class="ml_instruction h_layout"/>');
    const _lCard = widgets.card(icons[lInstruction.getCategory()], function () {
      if (lInstruction.getCategory() === 'waitFor' && lInstruction.getName() === 'event') {
        const lUnPackVariableName = lInstruction.getParameter('unpackVariableName');
        // Older waitForEvents did not have unpackVariable defined
        if(lUnPackVariableName){
          const lUpdatedUnpackVariable = lApp.removeOrUpdateUnpackVariable(lUnPackVariableName);
          if(lUpdatedUnpackVariable) {
            widgets.messageBox(`${lUnPackVariableName} is now defined as a Variable`, 'warning');
          }
        }
      }
      lSequence.removeInstruction(lSequence.getInstructionIndex(lInstruction));
    }).attr('id', widgets.idGenerator.nextInstructionId());
    const _lParameterMap = {};
    let lValues;
    let lLevelWidget;
    let lEdgeWidget;
    let _lFilteredActionsSet;
    const _lApplicationParameterObject = lApp.getParametersObject();
    // Note (alevy): this function does not return a widget
    // it adds widgets to _lCard
    const _parameterWidget = function (pParameterInfo, pParameter, pSkipAppend) {
      let _lWidget;
      const lIsSelectedInputPushButton = function() {
        const lSelectedInputUuid = lInstruction.getParameter('inputUuid');
        const lInput = lLibrary.getConfigManager().getInputByUuid(lSelectedInputUuid);

        if (lInput) {
          return lInput.getDeviceType() === 'pushButtonModule';
        } else {
          return false;
        }
      };

      switch (pParameterInfo.format) {
        case 'oneOf': {
          if (pParameterInfo.unit == 'ioExpander' && pParameterInfo.name == 'inputUuid') {
            _lWidget = io_widgets.inputParamWidget(
              lLibrary.getConfigManager(),
              'Input Name',
              pParameterInfo.description,
              pParameterInfo.default == ml.reservedUuids.NONE,
              lInstruction.getParameter(pParameter),
              function (pValue) {
                lInstruction.setParameter(pParameter, pValue);
                if (lInstruction.mName === 'digitalInput') {
                  lLevelWidget && lLevelWidget.updateLevelOptions();
                }
                else if (lInstruction.mName === 'digitalInputEdge') {
                  lEdgeWidget && lEdgeWidget.updateEdgeOptions();
                }
              });
          } else if (pParameterInfo.name == 'edge') {
            _lWidget = widgets.listWidget(pParameterInfo.name, [], pParameterInfo.description, lInstruction.getParameter(pParameter), function (pValue) { lInstruction.setParameter(pParameter, pValue); });
            _lWidget.updateEdgeOptions = () => {
              lValues = lIsSelectedInputPushButton() ? [{value: 'rising', text: "Released to Pushed"}, {value: 'falling', text: "Pushed to Released"}] : pParameterInfo.values;
              _lWidget.updateOptions(lValues);
              _lWidget.setValue(lInstruction.getParameter(pParameter));
            };
            _lWidget.updateEdgeOptions();
            lEdgeWidget = _lWidget;
          } else if (pParameterInfo.name == 'level') {
            _lWidget = widgets.listWidget(pParameterInfo.name, [], pParameterInfo.description, lInstruction.getParameter(pParameter), function (pValue) {
              lInstruction.setParameter(pParameter, parseInt(pValue));
            });
            _lWidget.updateLevelOptions = () => {
              lValues = lIsSelectedInputPushButton() ? [{value: 1, text: "Pushed"}, {value: 0, text: "Released"}] : pParameterInfo.values;
              _lWidget.updateOptions(lValues);
              _lWidget.setValue(lInstruction.getParameter(pParameter));
            };
            _lWidget.updateLevelOptions();
            lLevelWidget = _lWidget;
          } else if(pParameterInfo.unit === "axis" && pParameterInfo.name === "axis") {
            const lParameter = lInstruction.getParameter(pParameter);
            const lConfigManager = lLibrary.getConfigManager();
            const lName = pParameterInfo.name;
            const lTooltip = pParameterInfo.description;
            const lAllowedAxisType = pParameterInfo.allowedAxisType;
            const lOnValue = (pValue) => {
              lInstruction.setParameter(pParameter, pValue);
            };

            _lWidget = instruction_widgets.axisParamWidget(
              lConfigManager,
              lInstruction,
              pParameter,
              lName,
              lTooltip,
              false,
              lAllowedAxisType,
              lParameter,
              lOnValue
            );
          } else {
            _lWidget = widgets.listWidget(pParameterInfo.name, pParameterInfo.values, pParameterInfo.description, lInstruction.getParameter(pParameter), function (pValue) {
              lInstruction.setParameter(pParameter, pValue);
            });
          }
          break;
        }
        case 'array': {
          buildCombinedInstruction(_lCard, pParameterInfo);
          break;
        }
        case 'blank': {
          // This is to use blank for waitForEvent
          const hasBlankOnModel = lInstruction._getInstructionModel().parameters.find(function (paramObject) { return 'blank' === paramObject.format; });
          hasBlankOnModel && lInstruction.setParameter(pParameter, "blank"); // For UI purposes

          if (!pSkipAppend) {
            _lCard.parameters.append($('<div></div>'));
          }
          return $('<div></div>');
        }
        case 'integer': {
          // We support expressions in places that expect an integer. TODO: Put in a better comment
          _lWidget = autocompleteComponent(
            helpers.transformToTitleCase(pParameterInfo.name),
            pParameterInfo.description,
            lInstruction.getParameter(pParameter),
            lApp.listAllApplicationParameterNames(),
            (pValue) => { lInstruction.setParameter(pParameter, pValue); },
            [helpers.getExpressionValidationFunction(lApp.getParametersObject()), helpers.required],
            { getUnit: () => { return pParameterInfo.unit; } }
          ).widget;

          break;
        }
        case 'string': {
          if (pParameter == 'unpackVariableName') {
            // Check if this variable already exists
            const variableObject = lApp.getParameterObjectByName(lInstruction.getParameter(pParameter));

            _lWidget = widgets.applicationPackParameterWidget(lApp, variableObject, lSequence, lInstruction, pParameter);
            lInstructionListener = {
              /**  Listens to when a communication instruction parameter is changed (unpack variable)
                */
              onCommunicationMethodChange: function(removeInstructionIndex) {
                if (removeInstructionIndex == lSequence.getInstructionIndex(lInstruction)) {
                  lApp.removeApplicationParameter(variableObject.id);
                  lInstruction.removeListener(lInstructionListener);
                }
              }
            };
            lInstruction.addListener(lInstructionListener);
          } else if (pParameter.includes('topic')){
            // Determines the default value of the topic if lInstruction.getParameter(pParameter) does not exist
            const lCurParameter = function() {
              if (lInstruction.getParameter(pParameter)) {
                return lInstruction.getParameter(pParameter);
              } else {
                const lCounter =  pParameter.slice(13, 14);
                const topicName = 'MyTopic' + lCounter;
                lInstruction.setParameter(pParameter, topicName);
                return topicName;
              }
            };
            _lWidget = widgets.stringWidget(pParameterInfo.name, pParameterInfo.description, lCurParameter, function (pValue) {
              lInstruction.setParameter(pParameter, pValue);
            }, [helpers.required]);
          } else {
            // Determines the default value of the message (which is blank) if lInstruction.getParameter(pParameter) does not exist
            const lCurParameter2 = function() {
              if (lInstruction.getParameter(pParameter)) {
                return lInstruction.getParameter(pParameter);
              } else {
                lInstruction.setParameter(pParameter, '');
                return '';
              }
            };
            _lWidget = widgets.stringWidget(pParameterInfo.name, pParameterInfo.description, lCurParameter2, function (pValue) {
              _lWidget.children('input').attr('title', pValue);
              lInstruction.setParameter(pParameter, pValue);
            }, null, { allowEmpty: true });
          }
          break;
        }
        default: {
          _lWidget = widgets.baseWidget(pParameterInfo.name).append($('<div>' + pParameterInfo.format + ' not supported</div>'));
          break;
        }
      }

      if (_lWidget) {
        _lWidget.addClass('v_layout spaced');
        if (!pSkipAppend) {
          [-0][pParameter] = _lWidget;
          _lCard.parameters.append(_lWidget);
        }
        return _lWidget;
      }
    };
    const _lActionSet = lLibrary.getInstructionSet()[lInstruction.getCategory()];
    let _lActions;
    const _onAction = function (pAction) {
      if (['digitalInput', 'digitalInputEdge'].includes(pAction)) {
        if (lLibrary.getConfigManager().listInputs().length == 0) {
          widgets.messageBox('Please configure an input before using it. Your changes have been reverted.', 'warning');
          _lActions.setValue(lInstruction.getName());
          return;
        }
      }
      if (pAction == 'events') {
        if ( $(_lCard).find('.ml_parameters') ) {
          $(_lCard).find('.ml_parameters').attr('class', 'ml_parameters_waitFor g_layout spaced');
        }
      } else if (pAction !== 'events' && $(_lCard).find('.ml_parameters_waitFor')) {
        $(_lCard).find('.ml_parameters_waitFor').attr('class', 'ml_parameters g_layout spaced');
      }

      if (lInstruction.getCategory() === 'waitFor' && lInstruction.getName() === 'event') {
        const lUnPackVariableName = lInstruction.getParameter('unpackVariableName');
        const lUpdatedUnpackVariable = lApp.removeOrUpdateUnpackVariable(lUnPackVariableName);
        if(lUpdatedUnpackVariable) {
          widgets.messageBox(`${lUnPackVariableName} is now defined as a Variable`, 'warning');
        }
      }

      lInstruction.setName(pAction);
    };
    let buildInstruction = utils.buildInstruction(_parameterWidget);

    /**
       * Hash the parameters by parameters.name
       * @param {Array} pParameters - array of object parameters
       */
    const hashByName = function (pParametersInner) {
      return Object.values(pParametersInner).reduce(function (acc, parameter) {
        acc[parameter.name] = Object.assign({}, parameter);
        return acc;
      }, {});
    };

    /**
       * Build the right layout instruction
       * for listOfEvents, containing topic and message
       *
       * Clicking "add event" button at the bottom of the page should create a new event containing topic and message
       */
    const buildCombinedInstruction = function (pCard, pParameterInfo) {
      $(pCard).find('.ml_parameters').attr('class', 'ml_parameters_waitFor g_layout spaced');
      pCard.parameters.children().detach();
      // Note (alevy): we are looping through the topic count
      const junctionType = _lFilteredActionsSet.events.parameters.filter(parameter => parameter.name == 'junctionType')[0];
      const _lJunctionTypeWidget =  widgets.listWidget('Junction Type', junctionType.values, junctionType.description, lInstruction.getParameter('junctionType'), function (pValue) {
        lInstruction.setParameter('junctionType', pValue);
      });
      const lParametersHashed = hashByName(pParameterInfo.unit);
      const lTopic = lParametersHashed.topic;
      const lMessage = lParametersHashed.message;

      const _lRemoveEvent = function (rowNumber){
        const _lRemoveEventButton = widgets.inlineButtonWithText(icons.removeCircle, '',
          function () {
            $(`#blank_${rowNumber}`).remove();
            $(`#topic_${rowNumber}`).remove();
            $(`#message_${rowNumber}`).remove();
            $(`#removeButton_${rowNumber}`).remove();
            lInstruction.mParameters.listOfEvents.splice(rowNumber, 1);
          });
        return _lRemoveEventButton;
      };

      const uniqueEventID = function (pElementName) {
        let lCounter = 1;
        let lElementName = pElementName + '_' + lCounter;

        while ($(`#${lElementName}`).length >= 1) {
          lCounter += 1;
          lElementName = pElementName + '_' + lCounter;
        }

        return lElementName;
      };

      const _lAddEventButton = widgets.inlineButtonWithText(icons.addPlus, 'Event', function () {
        const appendCounter = pCard.parameters.children().length;
        const count = uniqueEventID(`blank`).split('_')[1];
        $(_parameterWidget({ "name": "blank", "format": "blank", "unit": "blank" }, pParameterInfo.name + '.' + count + '.blank', true )).insertAfter($(pCard.parameters.children().get(appendCounter - 8))).attr('id', uniqueEventID('blank'));
        $(_parameterWidget(lTopic, pParameterInfo.name + '.' + count + '.' + lTopic.name, true)).insertAfter($(pCard.parameters.children().get(appendCounter - 7))).attr('id', uniqueEventID(`topic`));
        $(_parameterWidget(lMessage, pParameterInfo.name + '.' + count + '.' + lMessage.name, true)).insertAfter($(pCard.parameters.children().get(appendCounter - 6))).attr('id', uniqueEventID(`message`));
        $(_lRemoveEvent(count).insertAfter($(pCard.parameters.children().get(appendCounter - 5))).attr('id', uniqueEventID(`removeButton`)));
        $(_lAddEventButton).insertAfter($(pCard.parameters.children().get(appendCounter - 2)));
      }).css({ 'display': 'show' });

      // Show the action list and junctionType only on the first line
      // First row
      pCard.parameters.append(_lActions);
      pCard.parameters.append(_lJunctionTypeWidget);
      _parameterWidget({ "name": "blank", "format": "blank", "unit": "blank" }, 'blank');
      _parameterWidget({ "name": "blank", "format": "blank", "unit": "blank" }, 'blank');

      // Second row
      _parameterWidget({ "name": "blank", "format": "blank", "unit": "blank" }, 'blank');
      _parameterWidget(lTopic, pParameterInfo.name + '.0.' + lTopic.name);
      _parameterWidget(lMessage, pParameterInfo.name + '.0.' + lMessage.name);
      _parameterWidget({ "name": "blank", "format": "blank", "unit": "blank" }, 'blank');

      // Remaining rows
      const eventCount = lInstruction.mParameters.listOfEvents.length;
      for (let i = 1; i < eventCount; ++i) {
        pCard.parameters.append((_parameterWidget({ "name": "blank", "format": "blank", "unit": "blank" }, pParameterInfo.name + '.' + i + '.blank', true )).attr('id', `blank_${i}`));
        $(_parameterWidget(lTopic, pParameterInfo.name + '.' + i + '.' + lTopic.name)).attr('id', `topic_${i}`);
        $(_parameterWidget(lMessage, pParameterInfo.name + '.' + i + '.' + lMessage.name)).attr('id', `message_${i}`);
        pCard.parameters.append($(_lRemoveEvent(i)).attr('id', `removeButton_${i}`));
      }

      // Second last row
      _parameterWidget({ "name": "blank", "format": "blank", "unit": "blank" }, 'blank');
      pCard.parameters.append(_lAddEventButton);
      _parameterWidget({ "name": "blank", "format": "blank", "unit": "blank" }, `${pParameterInfo.name}.${eventCount + 2}.blank`);
      _parameterWidget({ "name": "blank", "format": "blank", "unit": "blank" }, `${pParameterInfo.name}.${eventCount + 2}.blank`);
    };

    buildInstruction = utils.buildInstruction(_parameterWidget);
    _lCard.icon.find('h5').addClass('ml_number');
    _lCard.icon.removeClass('ml_icon').addClass('ml_icon_instruction_widget');

    if (_lActionSet) {
      _lFilteredActionsSet = utils.getActions(lLibrary, lInstruction);
      _lActions = widgets.listWidget(lInstruction.getCategory(), utils.getActionList(_lFilteredActionsSet), 'Action to be performed', lInstruction.getName(), _onAction);
      buildInstruction(_lCard, lInstruction, _lActions, _lFilteredActionsSet);
      _lCard.append($('<div class="ml_animated_background"/>'));
      _lDiv.append(_lCard);

      const lInstructionListeners = utils.getInstructionListener({
        actions: _lActions,
        buildInstruction: buildInstruction,
        card: _lCard,
        filteredActionsSet: _lFilteredActionsSet,
        instruction: lInstruction,
        library: lLibrary,
        parameterMap: _lParameterMap,
      });


      // Instruction and Application listeners
      lInstruction.addListener(lInstructionListeners);

      _lDiv.on('remove', function onRemoveWaitForInstruction() {
        lInstruction.removeListener(lInstructionListeners);
      });
    }

    return _lDiv;
  }

  /* Module export glue */
  /* global define */
  const gExports = {
    create: create,
  };

  const gModule = typeof module;
  if (gModule !== 'undefined' && module.exports != undefined) {
    module.exports = gExports;
  } else if (define != undefined && typeof define === 'function' && define.amd) {
    define([], function () { return gExports; });
  }
}());
